import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// ACCUMULATOR_ISSUE_DELETE_ATTACHMENT

const mutation = gql`
  mutation accumulatorIssueDeleteAttachment($id: ID!) {
    accumulatorIssueDeleteAttachment(id: $id) {
      id
      form_attachment {
        id
      }
    }
  }
`
export default function useAccumulatorIssueDeleteAttachment() {
  const { onMutate: onAccumulatorIssueAttachmentDelete, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'accumulatorIssueDeleteAttachment',
      successMessage: 'Attachment deleted'
    })

  return { onAccumulatorIssueAttachmentDelete, loading }
}
